import React from "react";
import styled from "styled-components";
import { PDescribe2 } from "../components/texts";
import { DecoratedH3 } from "../components/Headlines";
import { MainBtn } from "../components/Btns";
import { useContact } from "../contexts/ContactContext";

const StyledSection = styled.div`
    padding: 100px 30px;
    position: relative;
    width: 100%;

    background-image: url("/BG.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 70% 30%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media screen and (min-width: 800px) {
        padding: 100px;
        background-position: 60% top;
    }

    @media screen and (min-width: 1080px) {
        scroll-margin-top: 200px;
    }

    @media screen and (min-width: 1400px) {
        background-position: 60% 60%;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 800px;
    width: 100%;
`;

const CenteredText = styled(PDescribe2)`
    text-align: center;
`;

const StyledButton = styled(MainBtn)`
    margin-top: 50px;
`;

export default function About() {
    const { openContact } = useContact();
    return (
        <StyledSection id="about">
            <ContentWrapper>
                <DecoratedH3>About</DecoratedH3>
                <CenteredText $margin={"30px 0 20px 0"}>
                    Bubble designs, builds, and maintains websites for B2B tech teams. The same in-house crew handles all three - no handoffs, no waitlist. We work through a simple monthly retainer, and our edge is plain: hands-on ownership, fast turnarounds, and taking better care of your site than anyone else.
                </CenteredText>
                <StyledButton onClick={() => openContact()}>GET IN TOUCH</StyledButton>
            </ContentWrapper>
        </StyledSection>
    );
};